import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiDollarSign, FiPackage } from 'react-icons/fi';
import './ReportesMenu.scss';

const ReportesMenu = () => {
  const navigate = useNavigate();

  const reportCards = [
    {
      id: 'ventas',
      title: 'VENTAS',
      description: 'Reportes de ventas generales, por producto y por cliente. Desglose por semanas, meses, trimestres y años.',
      icon: FiDollarSign,
      gradient: 'purple',
      route: '/system/reportes/ventas'
    },
    {
      id: 'inventario',
      title: 'INVENTARIO',
      description: 'Control de inventario por departamento: Betel Natural, Naturalandlab, Otras marcas, Ingredientes y Materia prima.',
      icon: FiPackage,
      gradient: 'blue',
      route: '/system/reportes/inventario'
    }
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <div className="reportes-menu-page">
      <div className="reportes-menu-header">
        <h1 className="reportes-menu-title">Reportes Generales</h1>
        <p className="reportes-menu-subtitle">
          Selecciona el tipo de reporte que deseas consultar. Todos los reportes son exportables a PDF y pueden ser enviados por email.
        </p>
      </div>

      <div className="reportes-grid">
        {reportCards.map((card) => {
          const IconComponent = card.icon;
          return (
            <div
              key={card.id}
              className={`report-card report-card--${card.gradient}`}
              onClick={() => handleCardClick(card.route)}
            >
              <div className="report-card-icon">
                <IconComponent />
              </div>
              <div className="report-card-content">
                <h2 className="report-card-title">{card.title}</h2>
                <p className="report-card-description">{card.description}</p>
              </div>
              <div className="report-card-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportesMenu;
